import { Alert, Chip, Tooltip, Typography } from '@mui/material';
import { Snackbar } from '@mui/material';
import { useEffect, useState, useMemo, useCallback } from "react";
import ActionRenderer from "../components/ActionRenderer";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogContent, DialogTitle, SpeedDial, SpeedDialAction, SpeedDialIcon, Button, DialogActions, Toolbar, AppBar, IconButton } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AddIcon from '@mui/icons-material/Add';
import AddReport from "../components/AddReport";
import { getIntlTranslation } from "../../../utils/helper";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { miRoot } from "../../../utils/defaultValues";
import { useDispatch } from "react-redux";
import { archiveElement, createElement, getInspectionTemplate, getSiteDetails } from "../api/maintainenceInspectionApi";
import { useSelector } from "react-redux";
import { InfoOutlined, ViewModule, ViewList } from "@mui/icons-material";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ElementCard from "../components/ElementCard";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import Drawer from '@mui/material/Drawer';
import DefectList from '../components/DefectList';
import { fmtDE, getStatus } from '../utils/statusUtils';
import { useIntl } from 'react-intl';
import { DataGrid } from '@mui/x-data-grid';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PendingElementDialog from '../components/pendingElementDialog';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';

const MISiteOverview = () => {

    const intl = useIntl();

    const [successBanner, setSuccessBanner] = useState(false);
    const navigate = useNavigate()
    const location = useLocation();
    const { siteId } = useParams();
    const dispatch = useDispatch()

    const [openAddReport, setOpenAddReport] = useState(false)
    const [excel, setExcel] = useState(false)
    const [report, setReport] = useState(false)
    const [toggleView, setToggleView] = useState('grid');
    const [toggleDrawer, setToggleDrawer] = useState(false);
    const [drawerDefects, setDrawerDefects] = useState(null);
    const [addElement, setAddElement] = useState(false)

    const [rowToDelete, setRowToDelete] = useState(null);
    const [currentRow, setCurrentRow] = useState(null);
    const [siteInfo, setSiteInfo] = useState(null);
    const [pendingFlag, setPendingFlag] = useState(false);
    const [showArchived, setShowArchived] = useState(false);
    const [successBannerMessage, setSuccessBannerMessage] = useState('');
    const [protocol, setProtocol] = useState(false);
    const [radioButtonValue, setRadioButtonValue] = useState('');

    const currentSiteId = siteId;

    const askDelete = (row) => setRowToDelete(row);
    const closeDelete = () => setRowToDelete(null);
    const confirmDelete = () => {
        if (rowToDelete) setRowData(prev => prev.filter(r => r.id !== rowToDelete.id));
        setRowToDelete(null);
    };

    const handleViewClick = useCallback((row) => {
        console.log(location.state?.site, 'helloo')
        setCurrentRow(row);
        navigate(`${miRoot}/site-overview/${siteId}/protocols`, { state: { element: row, site: location.state?.site } })
    }, [navigate, siteId, location]);

    const handleArchiveClick = useCallback(async (row) => {
        await dispatch(archiveElement(row.id, siteId, !row?.archiveFlag))
        await dispatch(getSiteDetails(siteId));
        setSuccessBanner(true)
        if (row?.archiveFlag === false)
            setSuccessBannerMessage('Element archived successfully!')
        else
            setSuccessBannerMessage('Element unarchived successfully!')
        console.log('Archive clicked for row:', row);
    }, [dispatch, siteId, setSuccessBanner, setSuccessBannerMessage]);

    const handleCompletedClick = () => {
        setOpenAddReport(true);
        setExcel(false)
        setReport(true)
        setAddElement(false)
        setRadioButtonValue('existingElement')
        setPendingFlag(false)
    }
    const [rowData, setRowData] = useState([]);

    const unarchivedRowData = useMemo(
        () => rowData.filter((row) => !row.archiveFlag),
        [rowData]
    );

    const archivedRowData = useMemo(
        () => rowData.filter((row) => row.archiveFlag),
        [rowData]
    );

    const onStatusClick = (element) => {
        setPendingFlag(true);
        setCurrentRow(element);
    }

    useEffect(() => {
        console.log(`🔄 useEffect triggered - Fetching site details for ID: ${currentSiteId}`);

        if (currentSiteId) {
            console.log(`📡 API Call: getSiteDetails(${currentSiteId})`);
            dispatch(getSiteDetails(currentSiteId));
        } else {
            console.log('⚠️ No site ID available - skipping API call');
        }

        // Store site info from location.state if available  
        if (location.state?.site) {
            console.log('💾 Storing site info from navigation state:', location.state.site.name);
            setSiteInfo(location.state.site);
        } else {
            console.log('📭 No site info in navigation state');
        }
    }, [dispatch, currentSiteId, location.state]);

    const rows = useSelector((state) => state.maintainenceInspection?.siteDetails);
    useEffect(() => {
        const safeRows = Array.isArray(rows) ? rows : [];
        setRowData(safeRows);
    }, [rows]);

    const columns = useMemo(() => [
        {
            field: "elementName",
            headerName: intl.formatMessage({ id: "mi.element-name" }),
            minWidth: 310,
            headerAlign: "left",

            renderCell: (params) => (
                <span style={{ fontWeight: params.row?.archiveFlag ? 400 : 500, color: params.row?.archiveFlag ? '#6b7280' : 'inherit' }}>
                    {params.value}
                </span>
            ),
        },
        {
            field: "lastInspectionDate",
            headerName: intl.formatMessage({ id: "mi.last-inspection" }),
            minWidth: 170,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (
                <span style={{ color: "#6b7280", fontWeight: 500 }}>
                    {params.row.archiveFlag ? '-' : fmtDE(params.row.lastInspectionDate)}
                </span>
            ),
        },
        {
            field: "frequencyYears",
            headerName: intl.formatMessage({ id: "mi.frequency" }),
            minWidth: 110,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params) => (params.value ? `${params.value}y` : "-"),
            renderCell: (params) => (
                <span style={{ color: "#6b7280", fontWeight: 500 }}>
                    {params.row.archiveFlag ? '-' : `${params.value}y`}
                </span>
            ),
        },
        {
            field: "nextInspectionDate",
            headerName: intl.formatMessage({ id: "mi.next-inspection" }),
            minWidth: 170,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                const status = getStatus({
                    nextStr: params.row?.nextInspectionDate,
                    lastStr: params.row?.lastInspectionDate,
                    reinspectionStr: params.row?.reinspectionRequired,
                })
                const value = params.row.nextInspectionDate ? fmtDE(params.row.nextInspectionDate) : "" // string like "08.07.2028" or ISO etc.

                const isOverdue = status === "overdue";

                return (
                    <span
                        style={{
                            fontWeight: 700,
                            color: isOverdue ? "#aa3939" : "inherit",
                        }}
                    >
                        {params.row.archiveFlag ? '-' : value}
                    </span>
                );
            },
        },
        {
            field: "defectsFound",
            headerName: intl.formatMessage({ id: "mi.defects-found" }),
            align: "center",
            headerAlign: "center",
            sortable: false,
            filterable: true,
            minWidth: 140,
            renderCell: (params) => {
                const text = params.row.defectsFound ?? "";
                const hasDefects = text && String(text).trim().length;
                const label = params.row.archiveFlag ? '-' : hasDefects
                    ? intl.formatMessage({ id: "mi.found" })
                    : intl.formatMessage({ id: "mi.not-found" });

                return (
                    <span style={{ color: "#6b7280", fontWeight: 600 }}>
                        {label}
                        {hasDefects ? (
                            <Tooltip
                                title={'View Defects'}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setDrawerDefects(text);
                                    setCurrentRow(params.row);
                                    setToggleDrawer(true);
                                }}
                            >
                                <InfoOutlined
                                    style={{
                                        fontSize: 16,
                                        marginLeft: 4,
                                        verticalAlign: "middle",
                                    }}
                                />
                            </Tooltip>
                        ) : null}
                    </span>
                );
            },
        },
        {
            field: "status",
            headerName: intl.formatMessage({ id: "mi.status" }),
            align: "center",
            headerAlign: "center",
            minWidth: 140,
            valueGetter: (params) =>
                getStatus({
                    nextStr: params.row?.nextInspectionDate,
                    lastStr: params.row?.lastInspectionDate,
                    reinspectionStr: params.row?.reinspectionRequired,
                }),
            renderCell: (params) => {
                const value = params.value;
                const textColor =
                    value === "completed" ? "#97b444" : "#ffffff";
                const color =
                    value === "completed"
                        ? "#97b444"
                        : value === "overdue"
                            ? "#aa3939"
                            : "#ffc924";

                return (
                    <span
                        onClick={() => {
                            if (value !== "completed") {
                                setPendingFlag(!pendingFlag)
                                setCurrentRow(params.row)
                            }
                        }}
                    >
                        {
                            params.row.archiveFlag ?
                                <Chip
                                    label={intl.formatMessage({ id: `mi.archived` })}
                                    variant='outlined'
                                    sx={{
                                        width: 120,
                                        justifyContent: "center",
                                        fontWeight: 700,

                                        bgcolor: "transparent",
                                        color: "#6b7280",
                                        borderColor: "#6b7280",

                                        cursor: "default"
                                    }}
                                /> :
                                <Tooltip title='Complete the Inspection' disableHoverListener={value === 'completed'}>
                                    <Chip
                                        clickable={value !== "completed"}
                                        onClick={() => {
                                            if (value === "completed") return;
                                            onStatusClick(params.row);
                                        }}
                                        label={intl.formatMessage({ id: `mi.${value ?? "unknown"}` })}
                                        icon={value !== 'completed' ? <LaunchRoundedIcon color="inherit" fontSize="small" /> : undefined}
                                        size="small"
                                        variant={value !== 'completed' ? "filled" : "outlined"}
                                        sx={{
                                            width: 120,
                                            justifyContent: "center",
                                            fontWeight: 700,

                                            bgcolor: value !== 'completed' ? color : "transparent",
                                            color: textColor,
                                            borderColor: "#97b444",

                                            cursor: value !== 'completed' ? "pointer" : "default",

                                            ...(value !== 'completed' && {
                                                boxShadow: 1,
                                                "&:hover": {
                                                    filter: "brightness(0.95)",
                                                    color: color,
                                                    borderColor: color,
                                                },
                                                "&:active": {
                                                    transform: "translateY(1px)",
                                                },
                                                "& .MuiChip-icon": {
                                                    transition: "transform 120ms ease",
                                                },
                                                "&:hover .MuiChip-icon": {
                                                    transform: "translateX(2px)",
                                                    color: color,
                                                },
                                                "&.Mui-focusVisible": {
                                                    outline: "none",
                                                    boxShadow: `0 0 0 2px ${color}33`,
                                                },
                                            }),

                                            ...(value === 'completed' && {
                                                opacity: 0.9,
                                            }),
                                        }}
                                    />
                                </Tooltip>
                        }
                    </span>
                );
            },
        },
        {
            field: "reinspectionRequired",
            headerName: intl.formatMessage({ id: "mi.reinspection-required" }),
            align: "center",
            headerAlign: "center",
            sortable: false,
            filterable: true,
            minWidth: 250,

            renderCell: (params) => {
                const text = params.row?.reinspectionRequired ?? "";
                const normalized = String(text).trim();
                const isRequired = normalized.length > 0;

                const label = isRequired
                    ? intl.formatMessage({ id: "mi.yes" })
                    : intl.formatMessage({ id: "mi.no" });

                const openReinspection = () => {
                    if (!isRequired) return;
                    setCurrentRow(params.row);
                    setPendingFlag(true);
                };

                return (
                    <span style={{ color: "#6b7280", fontWeight: 600 }}>
                        <span
                            style={{
                                cursor: isRequired && !params.row.archiveFlag ? "pointer" : "default",
                                textDecoration: isRequired && !params.row.archiveFlag ? "underline" : "none",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 4,
                                justifyContent: "center",
                            }}
                            onClick={openReinspection}
                        >
                            {/* {isRequired ? <EventRepeatOutlined style={{ fontSize: 16 }} /> : null} */}
                            {isRequired ? `${label}${normalized ? ` · ${normalized}` : ""}` : "No"}
                        </span>
                    </span>
                );
            },
        },
        {
            field: "actions",
            headerName: intl.formatMessage({ id: "mi.actions" }),
            align: "center",
            headerAlign: "center",
            sortable: false,
            filterable: false,
            minWidth: 110,
            renderCell: (params) => (
                <ActionRenderer
                    protocolsUploaded={params.row.protocolsUploaded}
                    onDelete={() => askDelete(params.row)}
                    handleArchiveClick={() => handleArchiveClick(params.row)}
                    handleViewCLick={() => handleViewClick(params.row)}
                    showArchived={showArchived}
                    isArchived={params.row.archiveFlag}
                />
            ),
        },
    ], [handleArchiveClick, handleViewClick, intl, pendingFlag, showArchived]);

    const handleAddExcel = () => {
        setOpenAddReport(true)
        setExcel(true)
        setReport(false)
        setAddElement(false)
    };

    const handleAddAssetAI = () => {
        setOpenAddReport(true)
        setExcel(false)
        setReport(true)
        setAddElement(false)
    };

    const handleAddElement = () => {
        setOpenAddReport(true)
        setExcel(false)
        setReport(false)
        setAddElement(true)
    }

    const handleAddReportSubmit = async (data) => {
        if (excel && Array.isArray(data)) {
            await Promise.all(
                data.map(row => {
                    console.log('row', row);
                    return dispatch(createElement({ data: row }));
                })
            );
        } else if (addElement) {
            await dispatch(createElement({ data }));
        }
        // Refresh site details after all submissions complete
        if (currentSiteId) {
            await dispatch(getSiteDetails(currentSiteId));
            console.log('Site details refreshed for site ID:', currentSiteId);
        }
        // Show success banner
        setSuccessBanner(true);
        setSuccessBannerMessage(intl.formatMessage({ id: "mi.elements-added-successfully" }));
    };
    return (
        <>
            <Box sx={{ margin: 1 }}>
                <Button
                    variant="none"
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(`${miRoot}`)}
                    sx={{ mb: 1, color: '#254a9a', borderColor: '#254a9a' }}
                >
                    {intl.formatMessage({ id: '_back' })}
                </Button>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'row', justifyContent: 'space-between', marginRight: 1, marginLeft: 1 }}>
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: 600, color: '#254a9a' }}>
                        {location.state?.site?.name || rowData[0]?.site?.name}
                    </Typography>
                    <Typography variant="subtitle" sx={{ fontWeight: 600, mb: 2, opacity: 0.7 }}>
                        {location.state?.site?.street || rowData[0]?.site?.street}, {location.state?.site?.postalCode || rowData[0]?.site?.postalCode}, {location.state?.site?.city || rowData[0]?.site?.city}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                    <ToggleButtonGroup
                        value={toggleView}
                        exclusive
                        onChange={(_, val) => { if (val) setToggleView(val); }}
                        size="small"
                        aria-label="toggle view"
                    >
                        <ToggleButton value="grid" aria-label="Grid View">
                            <ViewList sx={{ mr: 1 }} /> {intl.formatMessage({ id: "mi.grid" })}
                        </ToggleButton>
                        <ToggleButton value="card" aria-label="Card View">
                            <ViewModule sx={{ mr: 1 }} />  {intl.formatMessage({ id: "mi.card" })}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>

            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} onClick={() => console.log('View Archived Elements')}>
                <Typography
                    variant="subtitle"
                    sx={{
                        fontWeight: 600,
                        mb: 2,
                        opacity: 0.7,
                        color: '#254a9a',
                        alignSelf: 'flex-end',
                        mr: 2,
                        textDecoration: 'underline',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        setShowArchived((prev) => !prev)
                    }}
                >
                    {showArchived
                        ? 'Show All Elements'
                        : 'Archived Elements'}
                </Typography>
            </Box>
            {toggleView === 'grid' ? (
                <Box sx={{ height: 'calc(100vh - 180px)', width: '100%' }}>
                    <DataGrid
                        sx={{
                            bgcolor: '#fff',
                            "& .MuiDataGrid-columnHeaderTitle": {
                                fontWeight: 700,
                            },
                            "& .MuiDataGrid-cell": {
                                display: "flex",
                                alignItems: "center",
                                px: 2
                            },
                            "& .MuiDataGrid-cell--textCenter": {
                                justifyContent: "center",
                            },
                            "& .MuiDataGrid-columnHeader--alignCenter": {
                                justifyContent: "center",
                            },
                            "& .MuiDataGrid-columnHeader": {
                                px: 2,
                            },
                        }}
                        rows={showArchived ? archivedRowData : unarchivedRowData}
                        columns={columns}
                        disableRowSelectionOnClick
                        pageSizeOptions={[10, 25, 50]}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 25 },
                            },
                        }}
                        density="standard"
                    />
                </Box>
            ) : (
                <Box
                    sx={{
                        height: 'calc(100vh - 120px)',
                        overflowY: 'auto',
                        px: 2,
                        py: 3,
                    }}
                >
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
                            gap: 1.5,
                            justifyItems: 'start',
                            alignItems: 'start',
                        }}
                    >
                        {showArchived ?
                            archivedRowData.map((el) => (
                                <ElementCard key={el.id} element={el} handleViewClick={() => handleViewClick(el)} onStatusClick={() => onStatusClick(el)} handleArchiveClick={()=>handleArchiveClick(el)} />
                            )) : unarchivedRowData.map((el) => (
                                <ElementCard key={el.id} element={el} handleViewClick={() => handleViewClick(el)} onStatusClick={() => onStatusClick(el)} handleArchiveClick={()=>handleArchiveClick(el)} />
                            ))}
                    </Box>
                </Box>
            )}
            <Drawer open={toggleDrawer} onClose={() => setToggleDrawer(false)} anchor="right" >
                <Box sx={{ width: 350, p: 2 }}>
                    <DefectList defects={drawerDefects} onClose={() => setToggleDrawer(false)} elementDetails={currentRow} />
                </Box>
            </Drawer>
            <Box sx={{ position: 'fixed', bottom: 40, right: 30, zIndex: 140 }}>
                <SpeedDial
                    ariaLabel="Add Options"
                    direction="up"
                    FabProps={{
                        sx: {
                            bgcolor: "#254a9a",
                            "&:hover": {
                                bgcolor: "#1e3d7a",
                            },
                        },
                    }}
                    icon={<SpeedDialIcon icon={<AddIcon sx={{ color: "#fff" }} />} />}>
                    <SpeedDialAction
                        icon={<DescriptionIcon />}
                        tooltipTitle={getIntlTranslation("mi.add-excel-file")}
                        onClick={handleAddExcel}
                    />
                    <SpeedDialAction
                        icon={<AutoAwesomeIcon />}
                        tooltipTitle={intl.formatMessage({ id: "mi.add-element-ai" })}
                        onClick={handleAddAssetAI}
                    />
                    <SpeedDialAction
                        icon={<FormatListBulletedIcon />}
                        tooltipTitle={intl.formatMessage({ id: "mi.add-element" })}
                        onClick={handleAddElement}
                    />
                </SpeedDial>
            </Box>
            <Dialog
                open={!!rowToDelete}
                onClose={closeDelete}
                fullWidth
                maxWidth="md"
                TransitionProps={{ unmountOnExit: true }}
                PaperProps={{ sx: { borderRadius: 2 } }}
            >
                <AppBar
                    className="appBar"
                    position="relative"
                    sx={{ bgcolor: "background.paper", color: "text.primary", }}
                >
                    <Toolbar className="dialog-toolbar" sx={{ display: "flex", justifyContent: "space-between", }}>
                        <DialogTitle>{getIntlTranslation("mi.delete-element")}</DialogTitle>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <IconButton
                                edge="end"
                                color="inherit"
                                aria-label="close"
                                onClick={closeDelete}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Toolbar>
                </AppBar >
                <DialogContent>
                    {getIntlTranslation("mi.delete-confirmation")} “{rowToDelete?.elementName}”?
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDelete}>{intl.formatMessage({ id: "cancel" })}</Button>
                    <Button onClick={confirmDelete} color="error" variant="contained">{intl.formatMessage({ id: "delete" })}</Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={successBanner}
                autoHideDuration={4000}
                onClose={() => setSuccessBanner(false)}
                anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
            >
                <Alert onClose={() => setSuccessBanner(false)} severity="success" sx={{ width: '100%' }}>
                    {successBannerMessage}
                </Alert>
            </Snackbar>

            {openAddReport ? <AddReport
                open={openAddReport}
                onClose={() => setOpenAddReport(false)}
                onSubmit={handleAddReportSubmit}
                onDownloadTemplate={() => {
                    dispatch(getInspectionTemplate())
                }}
                onUploaded={() => {
                    dispatch(getSiteDetails(siteId));
                }}
                excel={excel}
                report={report}
                siteId={siteId}
                inspectionId={currentRow?.id}
                elementList={rowData}
                addElement={addElement}
                protocol={protocol}
                radioButton={radioButtonValue}
                currentRow={currentRow}
            /> : null}
            {pendingFlag ? <PendingElementDialog element={currentRow} open={pendingFlag} onClose={() => setPendingFlag(false)} onCompletedClick={handleCompletedClick} /> : null}
        </>
    )
}

export default MISiteOverview